import { getCurrentTermsRequest } from '@/lib/recepthor-api';
import { useEffect, useState } from 'react';

// Reads the TyC catalog once, at flow init (the caller mounts this alongside
// the activation/login form, not lazily when the modal opens) — publishing a
// new version must not interrupt a flow already in progress, only the next
// one that starts. `error` is the "success path is catalog, fallback copy
// only on failure" signal: the caller falls back to hardcoded content when
// this fetch fails or the catalog is empty, and otherwise treats `catalog` as
// the source of truth.
export function useTermsCatalog() {
  const [state, setState] = useState({
    catalog: null,
    error: false,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const response = await getCurrentTermsRequest();
        if (!response.ok) throw new Error('terms catalog request failed');
        const catalog = await response.json();
        if (!cancelled) setState({ catalog, error: false, loading: false });
      } catch {
        if (!cancelled)
          setState({ catalog: null, error: true, loading: false });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
